import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import Collapse from "@material-ui/core/Collapse";
import InputLabel from "@material-ui/core/InputLabel";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: "99%",
  },
});
class DisplayExpertQuestionTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { classes, t } = this.props;
    return (
      <Collapse
        in={
          this.props.data.queryValue === null ||
          this.props.data.queryValue === this.props.parentValue
        }
        timeout="auto"
        unmountOnExit
      >
        {(this.props.data.queryValue === null ||
          this.props.data.queryValue === this.props.parentValue) &&
          (this.props.data.type === "Select" ? (
            <FormControl component="fieldset" className={classes.formControl}>
              <InputLabel className={this.props.inputClass}>
                {this.props.data.label}
              </InputLabel>
              <Select
                className={this.props.inputClass}
                value={this.props.data.value}
                classes={{
                  root: this.props.inputClass,
                  icon: this.props.inputClass,
                }}
                inputProps={{
                  className: this.props.inputClass,
                }}
                onChange={(event) =>
                  this.props.changeValue(event.target.value, this.props.data.id)
                }
              >
                {this.props.data.values.map((value) => (
                  <MenuItem value={value}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : this.props.data.type === "Radio" ? (
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend" className={this.props.inputClass}>
                {this.props.data.label}
              </FormLabel>
              <RadioGroup
                classes={{ root: this.props.inputClass }}
                aria-label="gender"
                name="gender1"
                value={this.props.data.value}
                onChange={(event) =>
                  this.props.changeValue(event.target.value, this.props.data.id)
                }
              >
                {this.props.data.values.map((value) => (
                  <FormControlLabel
                    value={value}
                    control={<Radio className={this.props.inputClass} />}
                    label={value}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          ) : this.props.data.type === "Checkbox" ? (
            <FormControl component="fieldset" className={classes.formControl}>
              <FormControlLabel
                className={this.props.inputClass}
                control={
                  <Checkbox
                    style={this.props.entry && { color: "white" }}
                    className={this.props.inputClass}
                    checked={
                      this.props.data.value != null
                        ? this.props.data.value
                        : false
                    }
                    onChange={(e) =>
                      this.props.changeValue(
                        e.target.checked,
                        this.props.data.id
                      )
                    }
                    color="primary"
                  />
                }
                label={this.props.data.label}
              />
            </FormControl>
          ) : this.props.data.type === "TextInput" ? (
            <FormControl component="fieldset" className={classes.formControl}>
              <KpsTextField
                onChange={(e) =>
                  this.props.changeValue(e.target.value, this.props.data.id)
                }
                InputProps={{ className: this.props.inputClass }}
                InputLabelProps={{ className: this.props.inputClass }}
                classes={{ root: this.props.inputClass }}
                value={this.props.data.value}
                defaultValue={this.props.data.default}
                label={this.props.data.label}
              />
            </FormControl>
          ) : (
            <FormControl component="fieldset" className={classes.formControl}>
              <KpsTextField
                onChange={(e) =>
                  this.props.changeValue(e.target.value, this.props.data.id)
                }
                InputProps={{ className: this.props.inputClass }}
                InputLabelProps={{ className: this.props.inputClass }}
                classes={{ root: this.props.inputClass }}
                value={this.props.data.value}
                defaultValue={this.props.data.default}
                label={this.props.data.label}
                multiline
                rows="6"
              />
            </FormControl>
          ))}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {this.props.data.expandedFrom.map((section) => (
            <DisplayExpertQuestionTemplate
              {...this.props}
              data={section}
              parentValue={
                this.props.data.value != null ? this.props.data.value : false
              }
            />
          ))}
        </div>
      </Collapse>
    );
  }
}
export default withTranslation()(
  withStyles(styles)(DisplayExpertQuestionTemplate)
);
